import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { planPeriod } from 'slices/membership/selectors';
import { RootState } from 'store';

const PlanDurationBanner: React.FC<{ onAction: (planId: string | number) => void }> = ({ onAction }) => {
    const { membership: membershipData, subscription_plans: plansData } = useSelector((state: RootState) => state.membershipState);
    const activePlan = membershipData?.data?.active_plan ?? null;

    const { planDaysLeft, planDaysCompletedPercentage, endsIn, state: planState, currentPlanDay, totalPlanDays } = useSelector(planPeriod);


    if (planState === 'expired') return null;

    if (planState === 'safe') return null;

    return (
        <div className={`trial-banner trial-banner--${planState} mt-3`}>
            <div className="radial-blur"></div>
            <div className='corner-circles'>
                <svg width="191" height="153" viewBox="0 0 191 153" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="188.5" cy="-35.5" r="188" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                    <circle cx="188.5" cy="-35.5" r="137" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                    <circle cx="188.5" cy="-35.5" r="86" stroke="white" strokeOpacity="0.2" strokeLinecap="round" strokeDasharray="4 4" />
                </svg>
            </div>
            <div className="d-flex gap-3">
                <div>
                    <h3 className='trial-banner-heading m-0'>
                        {
                            planState === 'safe' && `🎉 Welcome! Your ${activePlan?.plan?.name} trial is live`
                        }
                        {
                            planState === 'warning' && "⚠️ Only 2 days left for your plan to end"
                        }
                        {
                            planState === 'critical' && `🚨 Your subscription ${endsIn ? endsIn.toLowerCase() : 'ends in 1 day'}`
                        }
                    </h3>
                    <p className='trial-banner-description'>
                        {
                            planState === 'safe' && "Full access is active. Run campaigns, track collabs, analyze competitors everything is unlocked at no cost."
                        }
                        {
                            planState === 'warning' && `Don't lose your momentum. Your campaigns are live and performing renew your subscription before ${activePlan?.next_due_date} to keep everything running without interruption.`
                        }
                        {
                            planState === 'critical' && `Your ${activePlan?.plan?.name} Plan ends on ${activePlan?.next_due_date}. Subscribe now to keep campaigns live and avoid commission reverting to 20%.`
                        }
                    </p>
                    <div className="mt-4">
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="current-day">Day <strong>{currentPlanDay}</strong> of <strong>{totalPlanDays}</strong></span>
                            <span className="days-remaining">{planDaysLeft} Day{planDaysLeft !== 1 ? 's' : ''} Remaining</span>
                        </div>
                        <div className="trial-period-progress mt-1" style={{ background: '#D9D9D9' }}>
                            <div className="trial-period-progress-completed" style={{ width: `${planDaysCompletedPercentage}%`, backgroundColor: (planDaysLeft ?? 0) > 3 ? '#3CC0F8' : (planDaysLeft ?? 0) > 1 ? '#4C2E00' : '#FF2B3A' }}></div>
                        </div>
                    </div>
                </div>
                <div>
                    <button onClick={() => {
                        if (activePlan?.membership_plan_id) onAction(activePlan?.membership_plan_id);
                    }} className="trial-plan-action-btn">
                        SUBSCRIBE & KEEP {(activePlan?.plan?.name ?? '').toUpperCase()} PLAN
                    </button>
                </div>
            </div>


        </div>
    )
}

export default PlanDurationBanner